module.exports = __webpack_public_path__ + "static/bgVideos1204911-83ed2b98ef6f837af2717c7e5d914588.mp4";